export type UserRole = 'customer' | 'admin' | 'partner';

export const VALID_USER_ROLES: UserRole[] = ['customer', 'admin', 'partner'];
